import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import VideoSection from "../components/VideoSection";
import Verification from "../components/Verification";
import CarGrid from "../components/CarGrid";
import Deliveries from "../components/Deliveries";
import LiveTikTok from "../components/LiveTikTok";
import Contact from "../components/Contact";
import SellCar from "../components/SellCar";
import About from "../components/About";
import Location from "../components/Location";
import Footer from "../components/Footer";
import MobileContactBar from "../components/MobileContactBar";
import useReveal from "../hooks/useReveal";
import { fetchCars } from "../api";

// No validated Carmaps home video asset yet -> section stays hidden until a real
// URL is provided here (do NOT use placeholder/random videos).
const HOME_VIDEO_URL = "";

export default function Home() {
  const [cars, setCars] = useState([]);
  const [error, setError] = useState(false);
  useReveal(cars.length);

  useEffect(() => {
    fetchCars()
      .then((d) => setCars(d.cars || []))
      .catch(() => setError(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps -- load once on mount
  }, []);

  return (
    <>
      <Header />
      <main className="pb-20 lg:pb-0">
        <Hero car={cars[0]} />
        <VideoSection
          id="come-lavoriamo"
          videoUrl={HOME_VIDEO_URL}
          poster=""
          eyebrow="Auto vere. Persone vere."
          title="Non ti chiediamo di fidarti sulla parola. Ti mostriamo come lavoriamo."
          text="In meno di un minuto ti spieghiamo cosa controlliamo e quali informazioni puoi conoscere prima ancora di venire a vedere un'auto."
        />
        <Verification />
        {error ? (
          <div className="mx-auto max-w-[1360px] px-6 py-20 lg:px-10">
            <p className="text-[#6f6f68]">
              Al momento non riusciamo a caricare le auto. Riprova tra poco o
              chiamaci allo 011 283514.
            </p>
          </div>
        ) : (
          <CarGrid cars={cars} limit={6} />
        )}
        <Deliveries />
        <LiveTikTok />
        <Contact />
        <SellCar />
        <About />
        <Location />
      </main>
      <Footer />
      <MobileContactBar waText="Ciao Carmaps, vi scrivo dal sito." />
    </>
  );
}
